export default {
  en: {
    'pages.forgot-password.title': 'Forgot Password?',
    'pages.forgot-password.contact-message': 'Please contact support',
    'pages.forgot-password.valid-email': 'Please enter valid email address',
    'pages.forgot-password.email': 'Email:',
    'pages.forgot-password.submit': 'Submit',
    'pages.forgot-password.email-sent': 'There will be a link to reset your password',
    'pages.forgot-password.back-to-login': 'Back to login',
    'pages.forgot-password.contact.support': 'Contact support and request your email.',
    'pages.forgot-password.panel.title':
      'We will send instructions via email. Enter the email address used during registration.',
    'pages.forgot-password.forgot-email': 'Forgot email?',
    'pages.forgot-password.send-password': 'Send password',
    'pages.forgot-password.check.email': 'Check your email',
  },
};
